module.exports = __webpack_public_path__ + "assets/logo-247.svg?2943f046c98ae6efbb370d17445f71aa";